import {reactive, toRefs, computed, provide, inject} from "@vue/composition-api";
import ApiCalendar from '@/api/calendar/calendar'
import axios from "axios";
import Vue from "vue";

export const state = reactive({
    map: new Map(),
    list: [],
    types: [
        {"code": "training", "name": "Koolitus"},
        {"code": "article", "name": "Artikkel"},
        {"code": "holiday", "name": "Riigipüha"},
        {"code": "tax_date", "name": "Maksud"},
        {"code": "social", "name": "Nimepäev"},
        {"code": "shortened_working_day", "name": "Lühendatud tööpäev"},
        {"code": "event", "name": "Üritus"}
    ]
});

export const actions = {
    saveCalendarEvent(event_id, data) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/calendar/event/{0}".format(event_id)
            axios.post(url, data)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveCompanyCalendarEvent(data) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/company/calendar/event"
            axios.post(url, data)
                .then(function (resp) {
                    resolve(resp.status);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveAdminCalendarEvent(event_id, data) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/admin/calendar/event/{0}".format(event_id)
            axios.post(url, data)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteCalendarEvent(event_id) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/calendar/event/{0}".format(event_id)
            axios.delete(url)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteAdminCalendarEvent(event_id) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/admin/calendar/event/{0}".format(event_id)
            axios.delete(url)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    async fetchAdminCalendarEvent(event_id) {
        return new Promise(function (resolve, reject) {
            const url = Vue.config.url_prefix + "/api/admin/calendar/event/{0}".format(event_id)
            axios.get(url)
                .then(function (response) {
                    resolve(response.data)
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    async fetchCalendarEventList(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/admin/calendar/event_list/", {params: params})
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },

    async fetchCalendarPeriod(payload) {
        let response;
        try {
            state.list = await ApiCalendar.getCalendarPeriod(payload)
            return response;
        } finally {
            state.loading = false;
        }
    },

    async fetchCompanyCalendarList(params) {
        return new Promise(function (resolve, reject) {
            let temp_params = {'company_id': params}
            axios
                .get(Vue.config.url_prefix + "/api/calendar/company/", {params: temp_params})
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },

};

export const getters = {
    events: computed(() => state.list)
};

export const key = Symbol("CalendarEventModule");

export const provideEvent = () =>
    provide(key, {
        ...toRefs(state),
        ...toRefs(getters),
        ...actions
    });

export default () => inject(key);
